import { UserRole } from '@pya-mms/common';

type RoleCarrier = { role?: UserRole | string } | null | undefined;

export const IsAdmin = (authUser: RoleCarrier) => {
  if (!authUser) return false;
  return authUser.role === UserRole.Admin || authUser.role === UserRole.SuperAdmin;
};
